import React from 'react';
import { heroData } from '../../data/mock';
import { Home, TrendingUp, Shield } from 'lucide-react';

const TRUST_BADGES = [
  { icon: TrendingUp, label: 'Fast Closings', tint: 'emerald' },
  { icon: Shield, label: 'No Hidden Fees', tint: 'amber' },
  { icon: Home, label: 'Any Condition', tint: 'slate' },
];

const BADGE_BG = {
  emerald: 'bg-emerald-100',
  amber: 'bg-amber-100',
  slate: 'bg-slate-100',
};
const BADGE_FG = {
  emerald: 'text-emerald-600',
  amber: 'text-amber-600',
  slate: 'text-slate-600',
};

const HeroBackground = () => (
  <>
    <div className="absolute inset-0 opacity-[0.03]">
      <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }} />
    </div>
    <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-100 rounded-full blur-3xl opacity-40" />
    <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-100 rounded-full blur-3xl opacity-30" />
  </>
);

const TrustBadges = () => (
  <div className="flex flex-wrap justify-center gap-6 mb-12">
    {TRUST_BADGES.map(({ icon: Icon, label, tint }) => (
      <div key={label} className="flex items-center gap-2 text-slate-700">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${BADGE_BG[tint]}`}>
          <Icon className={`w-5 h-5 ${BADGE_FG[tint]}`} />
        </div>
        <span className="font-medium">{label}</span>
      </div>
    ))}
  </div>
);

const ScrollIndicator = () => (
  <div className="animate-bounce">
    <div className="w-8 h-12 border-2 border-slate-300 rounded-full mx-auto flex items-start justify-center pt-2">
      <div className="w-1.5 h-3 bg-slate-400 rounded-full" />
    </div>
  </div>
);

const HeroSection = () => (
  <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-white to-emerald-50">
    <HeroBackground />
    <div className="relative z-10 container mx-auto px-6 text-center">
      <div className="inline-flex items-center gap-3 mb-8 px-6 py-3 bg-white/80 backdrop-blur-sm rounded-full shadow-lg border border-emerald-100">
        <Home className="w-8 h-8 text-emerald-600" strokeWidth={2} />
        <span className="text-2xl font-bold text-slate-800 tracking-tight">{heroData.companyName}</span>
      </div>
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight max-w-4xl mx-auto">
        {heroData.tagline}
      </h1>
      <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl mx-auto leading-relaxed">
        {heroData.subtitle}
      </p>
      <TrustBadges />
      <ScrollIndicator />
    </div>
  </section>
);

export default HeroSection;
